module.exports = __webpack_public_path__ + "static/media/gemma_about-bg.0eeefbc7.jpg";